import Model from '@models/model';

import ApiClient from '@/api-client';

export default class Vendor extends Model {
    static className = 'Vendor';

    static allowsEdit = false;

    static allowedFieldEdits = [
        'name',
        'website',
        'account_number',
        'pay_to_name',
        'tax_id',
        'is_1099_eligible',
        'is_active',
        'is_hidden',
        'ap_term_id',
    ];

    resource() {
        return 'vendors';
    }

    static async getVendorContacts(vendorId) {
        try {
            return await ApiClient.getCollection(`/api/vendors/${vendorId}/contacts`);
        } catch (error) {
            throw new Error('Failed to get vendor contacts', error);
        }
    }
}
